<div class="flex-row">
    <div>
        <sidebar-menu>
            <div class="sidebar-title">
                <hr />
                <div>Employees</div>
            </div>

            <hr class="sidebar-hr" />

            <div class="sidebar-body">
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenuItem === employeesMenuEnum.StoreEmployees}"
                       (click)="onMenuItemClick(employeesMenuEnum.StoreEmployees)">Store Employees</a>
                </div>
                <div class="sidebar-block-link">
                    <a [ngClass]="{'active': activeMenuItem === employeesMenuEnum.WebAdmins}"
                       (click)="onMenuItemClick(employeesMenuEnum.WebAdmins)">Partner Portal Employees</a>
                </div>
            </div>
        </sidebar-menu>
    </div>

    <div class="sidebar-next-right-block">
        <xpress-topbar style="width: 100vw; display: block; margin-bottom: 20px;"></xpress-topbar>
        <partner-employees [typeMerchantUser]="activeMenuItem"></partner-employees>
    </div>
</div>
